
export function setEncryptPassword(password) {
    var CryptoJS = require("crypto-js");
    const newPassword = CryptoJS.AES.encrypt(JSON.stringify(password), `${process.env.REACT_APP_SECRET_KEY_PASSWORD}`).toString()
    return newPassword;
}